<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <div class="text-center mb-3">
        <img
          style="max-width: 200px"
          src="../assets/img/pickiddologolargesize.png"
        />
      </div>
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCard class="mx-4 mb-0 box-shadow">
            <CCardBody
              class="p-4"
              style="
                background: #fff;
                border-bottom-left-radius: 15px;
                border-bottom-right-radius: 15px;
              "
            >
              <CForm class="mt-3">
                <div v-if="ErrorMessage == true" class="">
          <CAlert show color="danger">
            <strong class="text-danger mr-2"
              >Wrong Code
            </strong>
          </CAlert>
        </div>
        <div v-if="SuccessMessage == true" class="">
          <CAlert show color="success">Successfully to Reset Password</CAlert>
        </div>
                <h5 class="text-center text-muted">Forgot Password !</h5>
                <h6 class="text-center">  Enter your email address below and we will you send a secret
                    number to reset your password(within 2 minutes)</h6>

                <br />
                <div v-if="hideemail == true">
                             
                              </div>
                              <div v-else>
                                 Email
                              <CInput
                                type="text"
                                v-model="userEmail"
                                placeholder="Enter your Email"
                              />
                              <div v-if="SubmittedForm === true">
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="ResetPassword"
                                  block
                                  disabled
                                  >Resetting</CButton
                                >
                              </div>
                              <div v-else>
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="Forgot"
                                  block
                                  >Reset Password</CButton
                                >
                              </div>
                              </div>
                              <br />
                              <div v-if="verify == true">
                                <CCard class="p-3">
                                  We've sent verification code to your email
                                  <br />
                                  <br />
                                  <CInput
                                    type="text"
                                    v-model="code"
                                    placeholder="Enter your verification code"
                                  />
                                  <br />
                                    <div v-if="VerifiedForm === true">
                                  <CButton
                                    color="success"
                                    class="custom-btn"
                                    type="submit"
                                    @click="ValidateCode"
                                    block
                                    disabled
                                    >Verified code</CButton
                                  >
                                    </div>
                                    <div v-else>
                                <CButton
                                  color="success"
                                  class="custom-btn"
                                  type="submit"
                                  @click="ValidateCode"
                                  block
                                  >Verify Password</CButton
                                >
                              </div>
                                </CCard>
                              </div>

                               <div v-if="change == true">
                                <CCard class="p-3">
                                  New Password
                                  <br /> <br />
                                  Enter your new password for your account to replace the old password
                                  <CInput
                                    type="password"
                                    v-model="newPassword"
                                    placeholder="Enter your password"
                                  />
                                  <CButton
                                    color="success"
                                    class="custom-btn"
                                    type="submit"
                                    @click="ChangePassword"
                                    block
                                    >New Password</CButton
                                  >
                                </CCard>
                              </div>

             
              </CForm>
            </CCardBody>
          </CCard>
          <div class="text-center mt-3">
            <label class="text-muted">Privacy Policy</label>
          </div>
        </CCol>
      </CRow>
    </CContainer>
    <div class="outer d-sm-down-none">
      <img style="max-width: 400px" src="../assets/img/login.png" />
    </div>

    <!-- <div class="outer-right">
      <img style="max-width: 350px" src="../assets/img/online.png" />
    </div> -->
  </div>
</template>

<script>
import backgroundUrl from "../assets/img/bgApps.png";

export default {
  name: "Login",
  e1: "#app",
  data: function () {
    return {
      ErrorMessage: false,
      SuccessMessage: false,
      verify: false,
      SubmittedForm: false,
      VerifiedForm: false,
      change: false,
      hideemail: false,

      userEmail: "",
      code: "",
      newPassword: "",

      Error: false,
      Message: "",
      noteModal: true,

      backgroundUrl,
    };
  },
  async mounted() {},
  methods: {
    GoToHome() {
      this.$router.push("/Dashboard");
    },
   Forgot() {
      this.SubmittedForm = true;
      this.verify = true;
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);

      return this.$API
        .post(this.$ForgotPassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
          } else {
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

          }
        });
    },
    ValidateCode() {
      this.SubmittedForm = true;
      this.VerifiedForm = true;
      this.verify = true;
      
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);
       formData.append("code", this.code);

      return this.$API
        .post(this.$ValidateForgotPasswordCode, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.change = true;
            this.hideemail = true;
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
    ChangePassword() {
      this.SubmittedForm = true;
       this.hideemail = true;
        this.VerifiedForm = true;
      this.verify = true;
      const formData = new FormData();

      formData.append("userEmail", this.userEmail);
       formData.append("code", this.code);
        formData.append("newPassword", this.newPassword);

      return this.$API
        .post(this.$ChangePassword, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data > 0) {
            this.verify = true;
            this.SuccessMessage = true;
              this.$router.push("Login");
          } else {
            this.ErrorMessage = true;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";

            this.ErrorMessage = true;
          }
        });
    },
  },
};
</script>
